export const equipmentsTypeNames = {
  gateways: 'Gateways',
  repeaters: 'Repeaters',
  sensorMotes: 'Sensor Motes',
  nodes: 'Nodes',
  tetheredSensors: 'Tethered Sensors',
  tachometers: 'Tachometers',
};
